import {TData, TPayload} from 'src/components/List';
import {TItemId} from 'src/constants';
import {CACHE_LIFETIME, ECacheTag, rootApi} from 'src/models';

import {TItem} from './definitions';

export const parametersApi = rootApi.injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    createParameter: builder.mutation<TItem, TItem>({
      query: (data) => ({
        method: 'POST',
        url: '/subscriber/parameter',
        data,
        meta: {
          isShowError: true,
          errorMessageKey: 'List:errors.failedToSaveItem',
          isShowSuccess: true,
          successMessageKey: 'List:notification.saveSuccess',
        },
      }),
      invalidatesTags: [ECacheTag.PARAMETERS],
    }),
    getAllParameters: builder.query<TItem[], {tenantId?: TItemId}>({
      query: ({tenantId}) => ({
        method: 'GET',
        url: !!tenantId ? '/subscriber/support/parameter' : '/subscriber/parameter',
        params: {tenantId},
        meta: {isShowError: true},
      }),
      keepUnusedDataFor: CACHE_LIFETIME,
      providesTags: (result) => {
        if (!result) {
          return [ECacheTag.PARAMETERS];
        }

        return [ECacheTag.PARAMETERS, ...result.map(({id}) => ({id, type: ECacheTag.PARAMETERS}))];
      },
    }),
    getParameters: builder.query<TData<TItem>, TPayload>({
      query: (data) => ({
        method: 'POST',
        url: '/subscriber/parameter/list',
        data,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {useCreateParameterMutation, useGetAllParametersQuery, useGetParametersQuery} =
  parametersApi;
